// const now = new Date();
// const jstOffset = 9 * 60 * 60 * 1000;
// const jst = new Date(now.getTime() + jstOffset);

// const month = jst.getUTCMonth() + 1;
// const day = jst.getUTCDate();
// const dayOfWeek = jst.getUTCDay();
// const hour = jst.getUTCHours();
// const isAfternoon = hour >= 12;

// let text = '';

// const isYearEndHoliday =
//   (month === 12 && day === 31) ||
//   (month === 1 && day >= 1 && day <= 4);

// if (isYearEndHoliday) {
//   text = '1月9日-10日';
// } else {
//   let addStart = 1;
//   let addEnd = 3;

//   if (dayOfWeek === 5 && isAfternoon) {
//     addStart = 4;
//     addEnd = 6;
//   }

//   const getFormattedDate = (baseDate, offset) => {
//     const d = new Date(baseDate);
//     d.setUTCDate(d.getUTCDate() + offset);
//     return {
//       month: d.getUTCMonth() + 1,
//       day: d.getUTCDate()
//     };
//   };

//   const start = getFormattedDate(jst, addStart);
//   const end = getFormattedDate(jst, addEnd);

//   if (start.month === end.month) {
//     text = `${start.month}月${start.day}日-${end.day}日`;
//   } else {
//     text = `${start.month}月${start.day}日-${end.month}月${end.day}日`;
//   }
// }

// const el = document.getElementById('delivery-date-range');
// if (el) el.textContent = text;

const now = new Date();
const jstOffset = 9 * 60 * 60 * 1000;
const jst = new Date(now.getTime() + jstOffset);

const month = jst.getUTCMonth() + 1;
const day = jst.getUTCDate();
const dayOfWeek = jst.getUTCDay();
const hour = jst.getUTCHours();
const isAfternoon = hour >= 12;

let text = '';

/* =========================
   ★ 特別ルール①
   2/24〜3/1 → 3/3-3/5
========================= */
const isSpecialFebRule =
  (month === 2 && day >= 24) ||
  (month === 3 && day === 1);

if (isSpecialFebRule) {
  text = '3月3日-5日';
}

/* =========================
   年末年始 特別ルール
   12/31〜1/4 → 1/9-1/10
========================= */
else {
  const isYearEndHoliday =
    (month === 12 && day === 31) ||
    (month === 1 && day >= 1 && day <= 4);

  if (isYearEndHoliday) {
    text = '1月9日-10日';
  } else {

    let addStart = 1;
    let addEnd = 3;

    if (dayOfWeek === 5 && isAfternoon) {
      addStart = 4;
      addEnd = 6;
    }

    const getFormattedDate = (baseDate, offset) => {
      const d = new Date(baseDate);
      d.setUTCDate(d.getUTCDate() + offset);
      return {
        month: d.getUTCMonth() + 1,
        day: d.getUTCDate()
      };
    };

    const start = getFormattedDate(jst, addStart);
    const end = getFormattedDate(jst, addEnd);

    if (start.month === end.month) {
      text = `${start.month}月${start.day}日-${end.day}日`;
    } else {
      text = `${start.month}月${start.day}日-${end.month}月${end.day}日`;
    }
  }
}

const el = document.getElementById('delivery-date-range');
if (el) el.textContent = text;